import AuthenticationContext from '../../../../Authentication/types/AuthContextType';
import { PureComponent } from 'react';
import { Filter, filterElement, RTMContainerProps, RTMContainerState, RTMProductDetail } from '../types/RTMTypes';
import RTMView from '../views/RTMView';
import _ from 'lodash';
import HttpClient from '../../../../HttpClient/SitesHttpClient';
import playIcon from '../../../../assets/icons/play.svg';
import pauseIcon from '../../../../assets/icons/pause.svg';
import RTMSkeleton from '../skeleton/RTMSkeleton';
import {
  handleFilter,
  prepareBodyToGetProductsByFilter,
  prepareStructureOfFilter,
  setFilterToAll,
} from '../utils/RTMFilterUtils';

class RTMContainer extends PureComponent<RTMContainerProps, RTMContainerState> {
  static contextType = AuthenticationContext;
  private httpClient: HttpClient | null = null;
  private refreshInterval: number | null = null;

  constructor(props: RTMContainerProps) {
    super(props);
    this.state = {
      loading: true,
      loadingTable: true,
      autoRefresh: false,
      tableFilter: {
        families: [],
        productTypes: [],
        products: [],
      },
      families: [],
      productsInTable: [],
      selectedProducts: [],
    };
  }

  componentDidMount = async () => {
    await this.getData('firstTime');
    const refreshButton = this.props.refreshButtonRef.current;
    if (refreshButton) {
      refreshButton.addEventListener('click', this.handleClickRefresh);
    }
  };

  componentWillUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  refreshTable = (skeletonStatus = true) => {
    this.setState({ loadingTable: skeletonStatus }, () => {
      this.getData('refresh');
    });
  };

  startRefreshCycle = (button: HTMLElement) => {
    const skeletonStatus = false;
    this.setState({ autoRefresh: true }, () => {
      this.refreshTable(skeletonStatus);
      button.classList.add('border-animation');
      const icon = this.props.imgRefreshButtonRef.current as HTMLImageElement;
      if (icon) {
        icon.src = pauseIcon;
      }
      this.refreshInterval = window.setInterval(() => {
        button.classList.remove('border-animation');
        void button.offsetWidth; // Force reflow
        button.classList.add('border-animation');
        this.refreshTable(skeletonStatus);
      }, 10000); // 10 sec interval
    });
  };

  stopRefreshCycle = (button: HTMLElement) => {
    this.setState({ autoRefresh: false }, () => {
      button.classList.remove('border-animation');
      const icon = this.props.imgRefreshButtonRef.current as HTMLImageElement;
      if (icon) {
        icon.src = playIcon;
      }
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    });
  };

  handleClickRefresh = () => {
    const refreshButton = this.props.refreshButtonRef.current;
    if (refreshButton) {
      if (!this.state.autoRefresh) {
        this.startRefreshCycle(refreshButton);
      } else {
        this.stopRefreshCycle(refreshButton);
      }
    }
  };

  productDetailsMapper = (productDetails: RTMProductDetail[]) => {
    return productDetails.map((productDetail) => {
      const selectedProduct = this.props.installation.products.find(
        (product: RTMProductDetail) => productDetail.puuid === product.puuid
      );
      return {
        ...productDetail,
        name: productDetail.name ? productDetail.name : `${selectedProduct?.productType.name} ${productDetail.puuid.slice(-4)}`,
      };
    });
  };

  getData = async (type: 'firstTime' | 'refresh') => {
    let filterToGetProducts: Filter;
    let tableFilter = this.state.tableFilter;

    if (type === 'firstTime') {
      tableFilter = prepareStructureOfFilter(this.props.installation.products);
      filterToGetProducts = setFilterToAll(this.props.installation.products);
    } else {
      filterToGetProducts = prepareBodyToGetProductsByFilter(this.state.tableFilter);
    }

    const allData = await this.getProducts(filterToGetProducts);
    if (allData && allData.status === 200 && allData.data?.content) {
      const { families, productDetails, selectedProducts } = allData.data.content;
      const mappedProductDetails: RTMProductDetail[] = this.productDetailsMapper(productDetails);

      this.setState({
        tableFilter,
        families,
        productsInTable: [...mappedProductDetails],
        selectedProducts,
        loading: false,
        loadingTable: false,
      });
    } else {
      console.log('error');
      this.setState({ loading: false, loadingTable: false });
    }
  };

  handleFilter = (
    type: 'families' | 'productTypes' | 'products',
    id: filterElement['id'],
    newStatus: filterElement['status']
  ) => {
    this.setState((prevState) => ({
      tableFilter: handleFilter(prevState.tableFilter, type, id, newStatus),
    }));
  };

  getProducts = async (filter: Filter) => {
    try {
      this.httpClient = new HttpClient(this.context);
      const response = await this.httpClient.SiteRTMProductStatus(this.props.installation.id, filter);
      return response;
    } catch (err) {
      console.log(err);
    }
    return false;
  };

  render() {
    return (
      <>
        {this.state.loading ? (
          <RTMSkeleton />
        ) : (
          <RTMView
            productsInTable={this.state.productsInTable}
            selectedProducts={this.state.selectedProducts}
            siteProducts={this.props.installation.products}
            siteId={this.props.installation.id as string}
            tableFilter={this.state.tableFilter}
            handleFilter={this.handleFilter}
            refreshTable={() => this.refreshTable()}
            getData={this.getData}
            loadingTable={this.state.loadingTable}
          />
        )}
      </>
    );
  }
}

export default RTMContainer;
